module.exports = {"id":"186456","name":"Jan-Arie van der Heijden","rating":"76","photo":"./data/images/photos/3/186456.png","club":{"name":"Feyenoord","logo":"./data/images/clubs/Feyenoord.png"},"positions":["DC"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/Jan-ArievanderHeijden0.json
// module id = 1911
// module chunks = 0